var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fields
    ? _c(
        "div",
        [
          _vm.where === "m"
            ? _vm._l(_vm.fields, function(field, ind) {
                return _c(
                  "div",
                  {
                    key: ind,
                    staticClass: "row no-wrap link",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.$emit("pass", field.link)
                      }
                    }
                  },
                  [
                    field.icon
                      ? _c("q-icon", { attrs: { name: field.icon } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { domProps: { innerHTML: _vm._s(field.html) } })
                  ],
                  1
                )
              })
            : _vm._l(_vm.fields, function(field, ind) {
                return _c("div", {
                  key: ind,
                  domProps: { innerHTML: _vm._s(field.html) }
                })
              })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73bb8829", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73bb8829","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/result-fields.vue
// module id = null
// module chunks = 